import React from 'react';
import styled from 'styled-components/macro';
import { PageTitle } from 'styles/appointment';
import { isEmpty } from 'lodash';

import ScheduleAppointmentModal from 'components/general/SchduleAppointmentModal';
import Button from 'components/ui/Button';

const ServiceButtons = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 20em;
  padding-bottom: 1.5em;
  overflow-y: auto;

  .service-button {
    width: 100%;
    max-width: 22em;
    margin: auto;

    &:not(:last-of-type) {
      margin-bottom: 1em;
    }
  }
`;

const Component = styled.div``;

const Location = ({
  organization,
  setStep,
  selectService,
  setSelectService,
  serviceOptions,
}) => {
  if (isEmpty(serviceOptions)) {
    return null;
  }

  const { logo } = organization;

  const handleButtonClick = (service) => {
    setSelectService(service);
  };

  const handlePrev = () => {
    setStep('location');
  };

  const handleNext = () => {
    setStep('scheduler');
  };
  const { id: selectedServiceId } = selectService || {};

  return (
    <ScheduleAppointmentModal
      logo={logo}
      handlePrev={handlePrev}
      handleNext={handleNext}
      nextButtonDisabled={!selectService}
    >
      <Component>
        <PageTitle>Select a service</PageTitle>

        <ServiceButtons>
          {serviceOptions.map((services) => {
            const { name, id } = services;

            return (
              <Button
                color="primary"
                key={id}
                onClick={() => handleButtonClick(services)}
                variant={selectedServiceId === id ? 'contained' : 'outlined'}
                className="service-button"
              >
                {name}
              </Button>
            );
          })}
        </ServiceButtons>
      </Component>
    </ScheduleAppointmentModal>
  );
};

export default Location;
